<template>
    <van-grid :column-num="3">
        <van-grid-item :icon="cust" text="门店员工" to="/storebeautyhead" />
        <van-grid-item :icon="send" text="客户分配" to="/sendcard" />
        <van-grid-item :icon="lamp" text="亮灯情况" to="/beautylamp" />
        <van-grid-item :icon="bigcard" text="大顾客" to="/bigcard" />
        <van-grid-item :icon="beauty31" text="31格" to="/cardddday31" />
        <van-grid-item :icon="indiba" text="INDIBA管理" to="/indibamanaer" />
        <van-grid-item :icon="salelog" text="销售日志" to="/beautysalelog" :badge="ccount"/>
        <!--<van-grid-item :icon="beautyex" text="导师目标" to="/beautyexamine"/>
        <van-grid-item :icon="staffex" text="美容师考核" to="/beautystaffexamine"/>-->
        <van-grid-item :icon="douyin" text="抖音成交率" to="/douyincjlv"/>
        <van-grid-item :icon="bigjk" text="大健康管理" :to="bigurl"/>
      <van-grid-item :icon="rank" text="导师业绩排名" to="/beautymanagerrank" v-show="show"/>
    </van-grid>
</template>
<script>
    export default {
        data() {
            return {
                show:false,
                cust:require('../../assets/cust.png'),
                lamp:require('../../assets/lamp.png'),
                send:require('../../assets/send.png'),
                bigcard:require('../../assets/bigcard.png'),
                beauty31:require('../../assets/beauty31.png'),
                indiba:require('../../assets/indiba.png'),
                salelog:require('../../assets/salelog.png'),
                beautyex:require('../../assets/beautyex.png'),
                staffex:require('../../assets/staffex.png'),
                douyin:require('../../assets/douyin.png'),
                bigjk:require('../../assets/bigjk.png'),
                rank:require('../../assets/rank.png'),
                ccount:0,
                storeid:localStorage.getItem("storeid"),
                bigurl:"",
            }
        },
        created() {
            let posid=localStorage.getItem("posid");
            if(posid=="d6511059fec84700a91a86e43436fd58"
              || posid=="ceb744d8bb9747849b3c7e997d0df357"
              || posid=="07434c86082d482cb5e3a9a8a5b8dbe8"
              || posid=="b7781c4e3f9249d9b3c5d2f1a183eae5"
              || posid=="94cbd462f6494dd79dcfc5ebe2e43c43"){
              this.show=true;
            }
            this.getCardTransactionHistoryByCardIdAccount();
            this.getStoreInfoByStructsOpen();
        },
        methods:{
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        if(res.object!=null && res.object.length>1){
                          this.bigurl="/bighealthytotal";
                        }
                        else{
                          this.bigurl="/bighealthy";
                        }

                    }
                    else{
                        this.$message({
                        message: res.message,
                        type: 'error'
                        });
                    }
                });
            },
            getCardTransactionHistoryByCardIdAccount(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("beautymanager/getCardTransactionHistoryByCardIdAccount",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.ccount=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/beauty/beautygrid.vue